//
//
//
//
//

export default {
  name: 'GoogleMap',
  props: {
    src: { type: String, default: '' },
    width: { type: String, default: '100%' },
    height: { type: String, default: '325' },
  },
  data() {
    return {
      mapPath: 'https://www.google.com/maps/embed/v1/place',
      mapKey: 'AIzaSyBqxNUmDZpLAf5gR69KR8b1KwaaVClQncs',
    };
  },
  computed: {
    mapUrl() {
      if (!this.src) return '';
      const mapTaget = this.src.replace(/^近|\d樓$/g, '');
      return `${this.mapPath}?key=${this.mapKey}&q=${mapTaget}`;
    },
  },
};
